const TYPES = {
    GET_PAGE: 'GET_PAGE',
    GET_PAGE_COMPLETE: 'GET_PAGE_COMPLETE',
    GET_PAGE_FAILED: 'GET_PAGE_FAILED'
};

export default {
    TYPES,

    getPage: (payload?) => ({
        type: TYPES.GET_PAGE,
        payload
    }),

    getPageSuccess: (payload?) => ({
        type: TYPES.GET_PAGE_COMPLETE,
        payload
    }),

    getPageFailed: (error?) => ({
        type: TYPES.GET_PAGE_FAILED,
        payload: {error}
    })
};
